import { GoogleAnalyticsEvent } from '../models/app.models';
import { logError, logInfo } from '../services/log.service';

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export const sendGoogleAnalyticsEvent = (event: GoogleAnalyticsEvent) => {
  try {
    // GA4 now runs inside the GTM container, so events are pushed to the
    // dataLayer in the shape GTM triggers expect. Ecommerce params (items)
    // are nested under `ecommerce` per the GA4 dataLayer convention.
    const payload = event.params?.items
      ? { event: event.name, ecommerce: { ...event.params } }
      : { event: event.name, ...event.params };

    if (typeof window === 'undefined') {
      return false;
    }

    // GTM is loaded through our custom first-party /metrics snippet rather
    // than Next's <GoogleTagManager> component. Push directly because
    // @next/third-parties' sendGTMEvent remains uninitialized in that setup.
    window.dataLayer = window.dataLayer || [];
    if (event.params?.items) {
      // Prevent fields from a previous ecommerce event being merged into this
      // one by GTM's data model.
      window.dataLayer.push({ ecommerce: null });
    }
    window.dataLayer.push(payload);
    logInfo([payload], 'Google Analytics Event');
    return true;
  } catch (error) {
    logError(
      [error, 'event', event.name, { ...event.params }],
      'Google Analytics Event'
    );
    return false;
  }
};
